// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#inbox[data-v-0f20d1f4]{width:258px;background-color:#f8fafb;border-right:1px solid #cfd8dc}", ""]);
// Exports
module.exports = exports;
